import { postEvent } from './dataHelpers';

// on button load
export const onButtonLoad = () => {
  const body = JSON.stringify({
    label: 'openchair',
    event_type: 'load',
    description: 'mainButton',
  });

  postEvent(body);
};

// on button hover
// export const onButtonHover = () => {
//   const body = JSON.stringify({
//     label: 'openchair',
//     event_type: 'hover',
//     description: 'mainButton',
//   });
// 
//   postEvent(body);
// };

// on button click
export const onButtonClick = () => {
  const body = JSON.stringify({
    label: 'openchair',
    event_type: 'click',
    description: 'mainButton',
  });

  postEvent(body);
};

// on appointment click
export const onAppointmentClick = () => {
  const body = JSON.stringify({
    label: 'openchair',
    event_type: 'click',
    description: 'appointment',
  });

  postEvent(body);
};

// "Review Details" button on form submit
export const onFormSubmissionClick = () => {
  const body = JSON.stringify({
    label: 'openchair',
    event_type: 'click',
    description: 'formSubmission',
  });

  postEvent(body);
};

// "Request Appointment" button (final submission)
export const onRequestSubmission = () => {
  const body = JSON.stringify({
    label: 'openchair',
    event_type: 'click',
    description: 'confirmBooking',
  });

  postEvent(body);
};

export const onMapClick = () => {
  const body = JSON.stringify({
    label: 'openchair',
    event_type: 'click',
    description: 'mapMarker',
  });

  postEvent(body);
}



// WEBPACK FOOTER //
// ./src/helpers/analytics.js